import styles from './styles/cta.module.css'

const CTA = () => (
  <section className={styles.ctaSection}>
    <h2>Let’s Build Your Dream Kitchen</h2>
    <p>Visit our showroom or call us today for a free consultation.</p>
    <a href="/#/contact-us" className={styles.ctaButton}>Contact Us</a>
  </section>
);


export default CTA;
